"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M14 14v1.17L17.17 12 14 8.83V10H6v4z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m20 12-8-8v4H4v8h8v4zM6 14v-4h8V8.83L17.17 12 14 15.17V14z"
}, "1")], 'ForwardTwoTone');